import { defineMessages } from 'react-intl';

const ID_PREFIX = 'EctlList.';
export const messages = defineMessages({
  eligibleSectionHeader: {
    id: `${ID_PREFIX}eligibleSectionHeader`,
    defaultMessage: 'Your eligible self-managed products'
  },
  claimedSectionHeader: {
    id: `${ID_PREFIX}claimedSectionHeader`,
    defaultMessage: 'Activated trials'
  },
  noActiveRecordsMessage: {
    id: `${ID_PREFIX}noActiveRecordsMessage`,
    defaultMessage: 'You’ve activated all of your cloud migration trials.'
  },
  multiEctlInstructions: {
    id: `${ID_PREFIX}multiEctlInstructions`,
    defaultMessage:
      'Select a product SEN to activate your trial. After your initial set up, return to this page to activate additional trials.'
  },
  ineligibleParOne: {
    id: `${ID_PREFIX}ineligibleParOne`,
    defaultMessage: 'You don’t appear to have any eligible products.'
  },
  ineligibleParTwo: {
    id: `${ID_PREFIX}ineligibleParTwo`,
    defaultMessage:
      'Free cloud migration trials are available for Jira Software, Confluence, Jira Service Desk, and Jira Core. You need to have more than 10 users or 3 agents – and have active, or recently expired, maintenance.'
  },
  ineligibleParThree: {
    id: `${ID_PREFIX}ineligibleParThree`,
    defaultMessage: 'Questions?'
  },
  ineligibleParFourContactUsLinkText: {
    id: `${ID_PREFIX}ineligibleParFourContactUsLinkText`,
    defaultMessage: 'Contact us'
  },
  loginVerbiage: {
    id: `${ID_PREFIX}loginVerbiage`,
    defaultMessage:
      'Please {loginCtaHtml} to view your eligible self-managed products.'
  },
  loginVerbiageLinkText: {
    id: `${ID_PREFIX}loginVerbiageLinkText`,
    defaultMessage: 'log in'
  }
});
